// extracted by mini-css-extract-plugin
module.exports = {"select":"ColorSelect-styles_select__28o7u"};